import { Mark } from "prosemirror-model";
import { Command, Transaction } from "prosemirror-state";

export function addMark(mark: Mark): Command {
	return (state, dispatch): boolean => {
		if (dispatch) {
			const {
				from,
				to,
				empty
			} = state.selection;

			const tr: Transaction = state.tr;

			if (empty) {
				tr.removeStoredMark(mark.type)
					.addStoredMark(mark);
			} else {
				tr.removeMark(from, to, mark.type)
					.addMark(from, to, mark);
			}

			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
}